
import { Prop, Vue, Watch, Component } from 'vue-property-decorator'
@Component
export default class SButton extends Vue {
  @Prop({ default: '' }) title!: string
  @Prop({ default: 'button' }) type!: string
  @Prop() disabled: boolean = false

  emitClick(event: any) {
    if (this.disabled) {
      return
    }
    this.$emit('click', event)
  }
}
